<template>
  <div>
    <h4>Getting Started</h4>
    <ol class="getting-started__steps mb-0 pl-0 list-unstyled text-left">
      <li>Check your email to verify your account.</li>
      <li>
        Download Nanome:
        <ul>
          <li v-for="link of links" :key="link.name">
            <b-link
              :href="link.href"
              :to="link.to"
              :gtm-info="link.gtm"
              class="text-white"
              target="_blank"
            >
              {{ link.label }}
            </b-link>
          </li>
        </ul>
      </li>
      <li>Launch Nanome and log in with your account.</li>
    </ol>
  </div>
</template>

<script>
export default {
  data: () => ({
    links: [
      {
        label: "Quest Store",
        href: "https://www.oculus.com/experiences/quest/2038368596280231",
        gtm: "home-download_oculus"
      },
      {
        label: "VivePort",
        href: "https://www.viveport.com/apps/0a467f78-2ed2-43eb-ada8-9d677d5acf54",
        gtm: "home-download_viveport"
      },
      {
        label: "Steam",
        href: "https://store.steampowered.com/app/493430/Nanome/",
        gtm: "home-download_steam"
      },
      {
        label: "Direct Download",
        href: "https://nanome.ai/setup",
        gtm: "home-download_direct"
      }
    ]
  })
};
</script>

<style lang="scss">
.getting-started__steps {
  counter-reset: steps;

  > li {
    position: relative;
    padding: 0.2em 0 1em 2.5em;

    &:before {
      counter-increment: steps;
      content: counter(steps);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 1.8em;
      height: 1.8em;
      border-radius: 50%;
      padding-top: 0.2em;
      color: #000;
      background: #fff;
    }
  }
}
</style>
